var map = {
	"./facebook.svg": [
		54051,
		51
	],
	"./instagram.svg": [
		16565,
		565
	],
	"./linkedin.svg": [
		60592,
		592
	],
	"./twitter.svg": [
		92038,
		38
	],
	"./youtube.svg": [
		89225,
		225
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 34693;
module.exports = webpackAsyncContext;